var _polygon, _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _polygon2, _polygon3, _polygon4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _path14, _path15, _path16, _path17, _rect5, _path18, _circle2, _circle3, _circle4, _circle5, _rect6, _circle6, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3f12c09-8e82-4948-a300-d3a23113d6dc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1144,
    height: 751.92352,
    viewBox: "0 0 1144 751.92352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3333") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1111.983 428.056 904.837 604.443 859.514 643.032 732.687 642.258 624.449 641.6 615.459 641.547 593.494 615.748 506.164 513.186 462.326 461.696 449.145 446.22 439.61 435.019 418.361 410.063 383.958 369.662 418.802 339.995 452.079 311.657 475.999 291.291 777.168 34.846 1111.983 428.056",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 101.92352,
    width: 397,
    height: 287,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 694.92352,
    width: 374,
    height: 2,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1161.92391,715.96176H862.57022s-6.068-88.99705,29.83423-90.00838,31.8569,39.44188,76.86109-16.18128,99.616-52.58916,106.69532-19.72093-13.653,59.1628,24.27192,51.07216S1192.76948,654.27062,1161.92391,715.96176Z",
    transform: "translate(-28 -74.03824)",
    fill: "#6415ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.19387,715.982l-1.01034-.04049c2.35623-58.59492,14.628-96.24277,24.50772-117.50687,10.72711-23.089,21.0641-32.4359,21.16731-32.52774l.67208.75578c-.10172.09086-10.31823,9.34492-20.95942,32.27762C1021.74606,620.11453,1009.54146,657.60782,1007.19387,715.982Z",
    transform: "translate(-28 -74.03824)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.53754,716.103l-.97084-.28246c11.69054-40.1263,39.22015-65.46091,39.49718-65.71226l.67949.74862C1154.46881,651.10627,1127.14512,676.26162,1115.53754,716.103Z",
    transform: "translate(-28 -74.03824)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M909.71978,716.03139l-1.00195-.13926c3.96631-28.60563-3.19818-50.79958-9.90714-64.38044-7.26424-14.70478-15.55265-22.73616-15.63561-22.81567l.69973-.72985c.0842.08049,8.50075,8.23532,15.84253,23.09763C906.489,664.77206,913.72139,687.17095,909.71978,716.03139Z",
    transform: "translate(-28 -74.03824)",
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 641.92352,
    width: 1101,
    height: 2,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 724.73526,
    y: 39.41333,
    width: 94.69491,
    height: 117.65125,
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "646.54 588.213 633.627 635.561 655.149 651.343 660.888 647.039 670.931 598.257 646.54 588.213",
    fill: "#ffb8b8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "808.669 583.909 804.365 641.3 831.626 641.3 831.626 588.213 808.669 583.909",
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "722.583 220.912 722.583 255.346 775.67 263.955 821.582 245.303 812.974 223.781 722.583 220.912",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M793.62624,323.64557l-45.91268-8.60863-11.47817,93.26014L707.54,524.51356s-43.04314,98.99922-37.304,121.95556l2.86954,7.17386-2.86954,12.91294,28.69543,11.47817,11.47817-18.652s8.60862,12.91294,22.95634-14.34771S807.974,448.47068,807.974,448.47068l10.0434,28.69542a59.1319,59.1319,0,0,0-1.43477,27.26066c2.86954,14.34771,5.73908,58.82562,5.73908,58.82562s-15.78248,77.47766,5.73909,83.21674l4.30431,17.21726,30.1302,2.86954,5.73908-17.21726s28.69543-10.0434,21.52157-60.26039-10.0434-215.2157-10.0434-215.2157l-28.26573-69.693Z",
    transform: "translate(-28 -74.03824)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M670.23591,706.72952s-7.17386-5.73909-10.0434-4.30432-32.99974,40.1736-32.99974,40.1736-31.565,24.39111-8.60863,27.26066,86.08628-28.69543,86.08628-35.86929-13.265-25.14061-13.265-25.14061S681.71408,716.77292,670.23591,706.72952Z",
    transform: "translate(-28 -74.03824)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M829.49553,702.4252s25.82588-1.60423,30.1302,2.78481,2.86954,25.91062,2.86954,25.91062,2.86954,38.73883-20.0868,38.73883-17.21726-25.82589-17.21726-25.82589Z",
    transform: "translate(-28 -74.03824)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 775.66964,
    cy: 58.78274,
    r: 35.86928,
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M779.99592,155.05994s20.0868,24.39111-20.0868,43.04314,28.69542,96.12968,28.69542,96.12968,80.3472-30.1302,73.17334-88.95583c0,0-48.78222-8.60863-37.304-48.78222Z",
    transform: "translate(-28 -74.03824)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M758.47435,196.6683s-32.99974-4.30431-34.43452,22.95635,0,93.26013,0,93.26013-14.34771,57.39086-7.17385,107.60785c0,0-8.60863,58.82563,14.34771,55.95609s5.73909-60.2604,5.73909-60.2604l10.0434-93.26014-4.30432-68.869,18.652-41.60837Z",
    transform: "translate(-28 -74.03824)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M853.44675,203.00687s31.28747-.59948,32.72225,22.35686-10.0434,93.26014-10.0434,93.26014l-17.21726,8.60863-15.78248-48.78223Z",
    transform: "translate(-28 -74.03824)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M862.49527,320.776l-2.86954,7.17385,8.60862,21.52157s-34.43451,27.26066-31.565,32.99974,18.652-7.17385,18.652-7.17385l22.95634,11.47817s18.652-20.0868,10.0434-38.73883-11.93374-31.03983-11.93374-31.03983S863.93,316.47171,862.49527,320.776Z",
    transform: "translate(-28 -74.03824)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M752.01788,191.64661l-4.30432,47.34745s-20.0868,20.0868,2.86954,47.34745l-2.86954,21.52157s53.08654-2.86954,63.12994,0,41.06045-2.31032,41.06045-2.31032l.54792-16.3417s14.34771-20.0868,10.0434-50.217,0-40.1736,0-40.1736l-10.0434-1.43477s-6.45647,43.76053-50.93438,48.06484c0,0-55.2387,5.0217-39.45622-53.80392Z",
    transform: "translate(-28 -74.03824)",
    fill: "#6415ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M807.25657,74.71274s-37.304-2.31257-45.91268,20.88478-23.67373,35.37595-23.67373,35.37595-23.73121,16.49592-11.8656,45.94364c0,0-36.91662,24.80826-12.52551,46.84574,0,0-1.43477,22.03748,12.91294,37.11575,0,0,11.47817,5.79934,7.17386,9.27894s28.69542,1.15987,25.82588-30.15655,16.49987-53.37608,16.49987-53.37608-18.652-40.60291-10.0434-54.52132c5.22667-8.45046,7.47125-14.75219,11.81013-18.39933a54.432,54.432,0,0,0,6.698-6.53682,15.45516,15.45516,0,0,1,16.64373-5.19065c12.91294,3.4796,15.78249,13.9184,15.78249,13.9184s9.326,24.93715,25.10849,36.53582-12.19555,31.89635-12.19555,31.89635,4.86321,23.89753,17.4967,38.04578-3.64082,26.48087-4.58376,28.06666c-2.15216,3.61936-10.747,26.47446,24.75672,26.5757,0,0,8.243-17.29677,19.72119-27.73557s2.86954-40.59536,2.86954-40.59536,17.21726-10.4388-1.43477-35.95588c0,0,5.73909-23.19735-10.0434-38.27562C878.27775,134.45307,856.0388,66.59367,807.25657,74.71274Z",
    transform: "translate(-28 -74.03824)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.93082,
    cy: 58.06535,
    rx: 3.58693,
    ry: 5.73909,
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M621,824.96176H29s-12-176,59-178,63,78,152-32,197-104,211-39-27,117,48,101S682,702.96176,621,824.96176Z",
    transform: "translate(-28 -74.03824)",
    fill: "#6415ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M315.00684,825.0018l-1.99805-.08008c4.65967-115.877,28.92822-190.3291,48.46631-232.38086,21.21386-45.66064,41.65625-64.145,41.86035-64.32666l1.3291,1.49463c-.20117.17969-20.40527,18.48047-41.44922,63.832C343.78516,635.41488,319.64941,709.56137,315.00684,825.0018Z",
    transform: "translate(-28 -74.03824)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M529.2666,825.24106l-1.91992-.5586c23.11914-79.35351,77.56152-129.45508,78.10937-129.95215l1.34375,1.48047C606.25684,696.704,552.22168,746.451,529.2666,825.24106Z",
    transform: "translate(-28 -74.03824)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.24268,825.09945l-1.98145-.27539c7.84375-56.57031-6.32471-100.46093-19.59228-127.31836-14.36573-29.08007-30.75684-44.96289-30.9209-45.12011l1.38379-1.44336c.1665.15918,16.811,16.28613,31.33007,45.67773C115.85352,723.72934,130.15625,768.02523,122.24268,825.09945Z",
    transform: "translate(-28 -74.03824)",
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 749.92352,
    width: 837,
    height: 2,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M593,463.96176H124v-372H593Zm-467-2H591v-368H126Z",
    transform: "translate(-28 -74.03824)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 170.92352,
    r: 17,
    fill: "#6415ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 170.92352,
    r: 17,
    fill: "#d0cde1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 170.92352,
    r: 17,
    fill: "#6415ff",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 170.92352,
    r: 17,
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 162.92352,
    width: 140,
    height: 16,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.99999,
    cy: 283.92352,
    r: 46,
    fill: "#f2f2f2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M316.1914,371.81039l-23.02-23.02a4.00026,4.00026,0,0,1,5.65723-5.65722l16.98,16.98,54.18408-61.78858a3.99986,3.99986,0,1,1,6.01465,5.27442Z",
    transform: "translate(-28 -74.03824)",
    fill: "#6415ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupIllustration);
export default __webpack_public_path__ + "static/media/signup-illustration.2876a99f67ce2b50caba20ca9da1e6ee.svg";
export { ForwardRef as ReactComponent };